<template>
  <div>
    <template v-if="inventoryStatus == 3">
      <span class="badge badge-danger"
        >Urgent</span
      >
    </template>
    <template v-else-if="inventoryStatus == 2">
      <span class="badge badge-danger"
        >Urgent</span
      >
    </template>
    <template v-else-if="inventoryStatus == 1">
      <span class="badge badge-warning"
        >Warning</span
      >
    </template>
    <template v-else>
      <span class="badge badge-success badge-green"
        >All Good</span
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    inventoryStatus: {
      required: true
    }
  }
}
</script>

<style>

</style>
